module.exports = __webpack_public_path__ + "static/media/delivery-truck.6ee48865.svg";